import { Action, BrowserHistory, createBrowserHistory, Location, State } from 'history';

export let history: BrowserHistory | null = null;

interface HistoryV4 {
  action: Action;
  location: Location;
  createHref: (location: Location) => string;
  push: (path: string, state: State) => void;
  replace: (path: string, state: State) => void;
  listen: (listener: (location: Location, action: Action) => void) => () => void;
  block: (blockFunction: (location: Location, action: Action) => string | void) => () => void;
  go: (delta: number) => void;
  goBack: () => void;
  goForward: () => void;
}

let historyV4: HistoryV4 | null = null;

history = createBrowserHistory();

// Only used for backwards compatibility reasons by the microfrontends
historyV4 = {
  get action() {
    return history!.action;
  },
  get location() {
    return history!.location;
  },
  createHref: history.createHref,
  push: history.push,
  replace: history.replace,
  go: history.go,
  goBack: history.back,
  goForward: history.forward,
  block: (legacyBlockFunction) => {
    const blockBeforeUnloadEvent = (event: BeforeUnloadEvent) => {
      event.stopImmediatePropagation();
    };

    window.addEventListener('beforeunload', blockBeforeUnloadEvent);

    let lastRetry: (() => void) | null = null;
    const unblock = history!.block(({ location, action, retry }) => {
      lastRetry = retry;
      legacyBlockFunction(location, action);
    });

    return () => {
      unblock();
      if (lastRetry) {
        lastRetry();
      }
      window.removeEventListener('beforeunload', blockBeforeUnloadEvent);
    };
  },
  listen: (legacyListener) => {
    return history!.listen(({ action, location }) => {
      legacyListener(location, action);
    });
  },
};

export default historyV4;
